
import React, { useState, useEffect } from 'react';
import { ONE_DAY, ONE_HOUR, errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import { getAuth, getCurrentServerTime, getPremiumPageDiscount, getUIState, getUser, isLoggedIn, isValidUser, saveDiscountForPremiumPlan, saveHomePageResponseData } from '../login/auth_utils';
import { getJsonDataPostRequest } from '../utils/network_utils';
import { BuyPremium} from './premium_discounts';
import { PremiumUserUI } from './premium_user_ui';
import LoginModal from '../login/email_login_modal';
import  { NavbarTop, NavbarWithOnlyHome } from '../ui_components/navbar_top';
import { BulkSubscriptionOneLine } from './bulk_subscription';


function PremiumHome() {
  // state values decide which ui will be displayed   
  const [state, setState] = useState(-1);  
  const [transactionsList, setTransactionsList] = useState(-1);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('')
  const [showProgressBar, setShowProgressBar]=useState(true)
  const [discount, setDiscount] = useState({})

  console.log("going to load payment home page ")
  const[user, setUser]=useState(getUser())
  // 3 for india , 0 for USA, 
  // making india default because customers have decreased.
  const [paymentRegionIndex, setPaymentRegionIndex]=useState(3) 
  
  useEffect(() => {
    console.log("fetching the payments data");
    /*if(!isLoggedIn()) {
        setState(0);
        setShowProgressBar(false)
        return;
    }*/
    setShowProgressBar(true)
    if(!isLoggedIn()) setState(getUIState())
    //else{
      let url = homeUrl()+"paymentsApi/fetchPaymentsHomePageData";
      getJsonDataPostRequest(url, getAuth(), function(response){
        setShowProgressBar(false);
        if(response == null){
          setError("Some error occurred, please try again")
          return
        }
        if(response.status>=400){
           setError(response?.message || "Some error occurred, please try again") 
           return    
        }
       // console.log(JSON.stringify(response))
        setPaymentRegionIndex(response.defaultCurrencyId)
        if(response.discount) setDiscount(response.discount)
        else setDiscount(getPremiumPageDiscount())
        setTransactionsList(response.transactions)
        setUser(getUser())
        saveHomePageResponseData(response)
        setState(getUIState())
        
      })
   //}
     
}, []); // empty bracket means there are no dependencies which will make useEffect re run

  return (
  <div className="min-h-screen w-full bg-gradient-to-b from-white via-slate-50 to-white text-slate-900">
  { state!=3 && <NavbarWithOnlyHome />
  }
  { state==3 && <NavbarTop />
  }

    <div className={state == 3 ? 'pt-28 md:pt-32' : 'pt-24 md:pt-28'}></div>

    <div className="flex w-full flex-col items-center justify-start px-3 sm:px-5 md:px-8">
      <div className="w-full max-w-7xl">
        <div className="mb-4 flex flex-col items-center justify-center text-center md:mb-6">
          <p className="z-10 m-0">
            <span className="
              font-sans text-4xl font-extrabold tracking-tight
              text-slate-950 drop-shadow-sm
              sm:text-5xl md:text-6xl
            ">
              Premium
            </span>
          </p>

          <div className="mt-3 flex items-center justify-center gap-2">
            <span className="h-1.5 w-12 rounded-full bg-blue-600"></span>
            <span className="h-1.5 w-2 rounded-full bg-blue-600"></span>
            <span className="h-1.5 w-12 rounded-full bg-blue-200"></span>
          </div>
        </div>

        {
          state==0 && 
          <div className="mt-4 flex w-full flex-col items-center justify-center text-center">
            <div className=' hidden 
            first-letter:text-lg font-medium text-gray-500'>
              Please Login to View Premium Plan <br /></div>
            
            <div className="mb-4 flex w-full justify-center">
              <LoginModal />
            </div>

            {
              <BuyPremium discount={discount}
                paymentRegionIndex={paymentRegionIndex} 
                setPaymentRegionIndex={setPaymentRegionIndex}/>
            }
            
          </div>
        }

        {
          (state==1 || state==2) && 
          <BuyPremium discount={discount} 
                      paymentRegionIndex={paymentRegionIndex} 
                      setPaymentRegionIndex={setPaymentRegionIndex} />
        }

        {
          state==3 && 
          <div className="flex w-full flex-col items-center justify-center">
          <PremiumUserUI 
            user={user} transactions={transactionsList} />

            
            </div>
        }
      
        {showProgressBar &&
        <div className="mt-20 flex w-full items-center justify-center">
          <div className="z-50 rounded-2xl bg-white px-8 py-6 shadow-sm ring-1 ring-slate-200">
            <IndefiniteProgressBar />
          </div>
        </div> 
        }

        {error && error.length>0 &&
        <div className="mx-auto mt-6 max-w-2xl rounded-2xl border border-red-100 bg-red-50 px-5 py-3 text-center text-base font-semibold text-red-700 shadow-sm">
        {error} <br /> 
        </div>
        }

        {message && message.length>0 && !error && error.length==0 &&
        <div className="mx-auto mt-6 max-w-2xl rounded-2xl border border-blue-100 bg-blue-50 px-5 py-3 text-center text-lg font-bold text-blue-700 shadow-sm">
        {message} <br /> 
        </div>
        }

        <div>

        { // hiding bulk subscription link
        // its confusing and nobody ever bought it. 
        false && <div className="flex flex-col 
          items-center justify-center">
          
          <BulkSubscriptionOneLine />
          </div>
          }
          <br /> <br /> <br /><br />
        </div>
      </div>
    </div>
</div>
  );
        
}

export default PremiumHome;